import React from 'react';
import './Spin.css'

const Spin = () => {
  return (
    <svg className="spinner text-green-500" viewBox="0 0 50 50" stroke="currentColor" strokeWidth="5" strokeLinecap="round" fill="none">
      <circle cx="25" cy="25" r="20"></circle>
    </svg>
  );
};

export default Spin;
